<!-- TODO 複雑になった場合はコンポーネントを分ける -->
<div class="auth0-error-container">
    <!-- アクセス期限切れエラーの場合 -->
    <ng-container *ngIf="isShowAccessExpired; else elseBlock">
        <div class="auth0-error-box">
            <p class="auth0-error-title">URLの期限が切れています</p>
            <p class="auth0-error-message">お手数をお掛けしますが、もう一度、メール送信からを再度実施いただけるようお願い申し上げます。</p>
        </div>
    </ng-container>
    <ng-template #elseBlock>
        <!-- それ以外 -->
        <div class="auth0-error-box">
            <p class="auth0-error-title">認証エラー</p>
            <p class="auth0-error-message">error_code: {{params?.error}}: {{params?.error_description}}</p>
        </div>
    </ng-template>
</div>
